import React, {Component} from 'react';
import {Tooltip, Icon, Modal, Input, message} from "antd";
import {uuid} from "../../../utils";
import {getFileImage} from "../UploadWall";

class OtherNormalFileItem extends Component {

    static defaultProps = {
        showEdit: true
    };

    state={
        visible:false,
        isHover: "none",
    };

    fileNameDialogKey=uuid();
    fileName;

    renderMask(file, size){
        let percent = file.percent;
        let allWidth = size - 10;
        let msg = "上传中...";
        if(percent === 100){
            if(file.response && file.response.path){
                return <></>;
            }else{
                msg = "处理中...";
            }
        }
        return <>
            <div style={{width:size,height:size, background:"#000",position:"absolute",zIndex:997,top:10,left:30,opacity:0.5}}/>
            <div style={{color:"#fff",position:"absolute",zIndex:999,top:25,left:40}}>{msg}</div>
            <div style={{width:allWidth,height:5,background:"#fff",position:"absolute",zIndex:998,left:35,bottom:18,borderRadius:5}}/>
            <div style={{width:allWidth * percent / 100,height:5,background:this.themeBgColor,position:"absolute",zIndex:998,left:35,bottom:18,borderRadius:5}}/>
        </>
    }

    render() {
        const {file, size} = this.props;
        // console.log(file)
        if(!this.fileName){
            this.fileName = file.originFileObj.name;
        }
        if(!this.fileName){
            this.fileName = file.name;
        }
        let ext = this.fileName.replace(/.*\./, "");
        let src = getFileImage("", ext);
        let percent = file.percent;
        const imgSize = 69;
        // console.log("file:   ", src, file);
        return <table cellPadding={0} style={{background:"#f4f6fc",border:"1px solid #f1f3f4",marginRight: 20,marginBottom: 32,float:"left"}} cellSpacing={0} width={size} height={size}><tbody><tr>
            <td height={89} valign={"middle"} align={"center"} style={{position:"relative"}}
                onMouseEnter={() =>{
                    if(file.status==='done'){
                        this.setState({isHover: "block"})
                    }
                }}>
                <div style={{display: this.state.isHover}}
                     onMouseLeave={() => this.setState({isHover: "none"})}>
                    <div style={{
                        width: 131,
                        height: 89,
                        background: 'rgba(0,0,0,0.4)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'absolute',
                        padding: '0 10px',
                        top:0,
                        zIndex:9
                    }}>
                        <Icon type={'delete'} style={{width: 25, height: 25, color: "#fff", cursor: 'pointer'}}
                            onClick={() => {
                                  this.fileName =""
                                  this.props.onRemove(file)
                              }}
                        />
                    </div>
                </div>
                <img src={src} style={{objectFit:"cover",width:32,height:36}} />
                {
                    (()=>{
                        // let fileName = this.fileName;
                        let initialFileName = this.fileName;
                        let fileName = initialFileName.split('.').shift()
                        console.log('fileName----: ', fileName);
                        let fileExtension = initialFileName.split('.').pop(); // 提取文件扩展名
                        console.log('fileExtension: ', fileExtension);
                        return <Modal
                            key={this.fileNameDialogKey}
                            title={"修改名称"}
                            maskClosable={false}
                            width={300}
                            visible={this.state.visible}
                            onOk={()=>{
                                if (fileName) {
                                    this.fileName = `${fileName}.${fileExtension}`; // 附加文件扩展名
                                    this.setState({ visible: false });
                                    let file = JSON.parse(JSON.stringify(this.props.file));
                                    file.originFileObj.name = this.fileName;
                                    this.props.onEditFileNameCall(file, this.fileName);
                                } else {
                                    message.destroy();
                                    message.error("标题不能为空！");
                                }
                            }}
                            onCancel={()=>{
                                this.fileNameDialogKey=uuid();
                                this.setState({visible:false})
                            }}
                        >
                            <Input defaultValue={fileName} onChange={(e) => { fileName = e.target.value }}/>
                        </Modal>
                    })()
                }
                {this.renderMask(file, imgSize)}
            </td>
        </tr>
        <tr>
            <td style={{padding:"0 10px",justifyContent: "spaceBetween", display: "flex"}} valign={"middle"} align={"center"}>
                <Tooltip placement={"bottomLeft"} title={this.fileName}><div className={"text-pointer"} style={{width:size-(this.props.showEdit?35:21)}}>{this.fileName}</div></Tooltip>
                {this.props.showEdit && <div><Icon type={"edit"}
                           onClick={()=>percent === 100 &&this.setState({visible:true})}
                           style={{color:this.themeBgColor,cursor:"pointer"}}
                /></div>}
            </td>
        </tr></tbody>
        </table>;
    }
}

export default OtherNormalFileItem;
